export const TEXT = {
  documentTitle: 'Прямые эфиры с преподавателем',
  title: {
    free: {
      firstText: 'Бесплатный эфир',
      secondText: 'с преподавателем',
      thirdText: 'Эфир пройдёт в ноябре — точную дату и время отправим на email',
      thirdText960: 'Эфир пройдёт в ноябре — точную дату и время отправим\nна email',
      thirdText640: 'Эфир пройдёт в ноябре — точную\nдату и время отправим на email',
    },
    sub: {
      firstText: 'Прямые эфиры',
      secondText: 'с преподавателем',
      thirdText: 'От астрономии до финансовой грамотности: рассмотрим самые разные темы вместе',
      thirdText1280:
        'От астрономии до финансовой грамотности: рассмотрим самые разные темы\nвместе',
      thirdText960: 'От астрономии до финансовой грамотности: рассмотрим\nсамые разные темы вместе',
      thirdText640:
        'От астрономии до финансовой\nграмотности: рассмотрим самые\nразные темы вместе',
    },
  },
  form: {
    price: '73 ₽ / занятие',
    title: 'Что будет на эфире',
    info: {
      first: 'Объяснение темы с наглядными примерами',
      second: 'Командные игры, викторины и соревнования',
      third: 'Живое общение и ответы на вопросы',
    },
    additionalInfo:
      'Безлимитный доступ ко всем эфирам на 6 месяцев.\nКаждый месяц не менее 5 эфиров!',
    buttonText: {
      withSub: 'Оформить подписку за 2190 ₽',
      withoutSub: 'Записаться бесплатно',
    },
    textAfterButton: 'После оплаты откроем доступ\nв личном кабинете ребёнка на Учи.ру',
  },
};

export const ONE_MANY_KEY = 'ONE_MANY';

export const FAKE_DOOR_PATH = 'https://uchi.ru/payments/provider/oneMany';
